// Audit event payloads are stored as JSON strings; these helpers read them
// without letting a malformed one break a table row.
export function parseAuditData(data: string): Record<string, unknown> | null {
  if (!data) return null;
  try {
    const parsed = JSON.parse(data);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

// The clicker evidence row an event points at, when it has one. Older events
// carry sidecar file paths instead and have no id.
export function auditEvidenceId(data: string): number | null {
  const parsed = parseAuditData(data);
  const id = parsed?.evidenceId;
  return typeof id === 'number' && Number.isInteger(id) && id > 0 ? id : null;
}

export function prettyJson(value: unknown): string {
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  return JSON.stringify(value, null, 2);
}
